import { useSettings } from '../context/Settings';
import { LanguageCodes } from '../i18n/i18n';

export const useLanguageHelper = () => {
  const { settings } = useSettings();
  const language = settings.language;
  const isNewLanguage = language !== LanguageCodes.sv && language !== LanguageCodes.nl && language !== LanguageCodes.de;
  const showCampusButton = language === LanguageCodes.de || language === LanguageCodes.es;

  const isEnglish = language === LanguageCodes.en;

  return { isNewLanguage, isEnglish, showCampusButton };
};
